/* tslint:disable */
/* eslint-disable */
/**
 * Litiverse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Document,
  DocumentCreate,
  DocumentUpdate,
  HTTPValidationError,
} from '../models/index';
import {
    DocumentFromJSON,
    DocumentToJSON,
    DocumentCreateFromJSON,
    DocumentCreateToJSON,
    DocumentUpdateFromJSON,
    DocumentUpdateToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
} from '../models/index';

export interface CreateDocumentApiV1DocumentsPostRequest {
    documentCreate: DocumentCreate;
}

export interface CreateDocumentApiV1DocumentsPost0Request {
    documentCreate: DocumentCreate;
}

export interface DeleteDocumentApiV1DocumentsIdDeleteRequest {
    id: number;
}

export interface ReadDocumentApiV1DocumentsIdGetRequest {
    id: number;
}

export interface ReadDocumentsApiV1DocumentsGetRequest {
    skip?: number;
    limit?: number;
}

export interface ReadDocumentsApiV1DocumentsGet0Request {
    skip?: number;
    limit?: number;
}

export interface ReadDocumentsByProsecutionApiV1DocumentsProsecutionProsecutionIdGetRequest {
    prosecutionId: number;
}

export interface ReadDocumentsByProsecutionApiV1DocumentsProsecutionProsecutionIdGet0Request {
    prosecutionId: number;
}

export interface UpdateDocumentApiV1DocumentsIdPutRequest {
    id: number;
    documentUpdate: DocumentUpdate;
}

/**
 * 
 */
export class DocumentsApi extends runtime.BaseAPI {

    /**
     * Create new document.
     * Create Document
     */
    async createDocumentApiV1DocumentsPostRaw(requestParameters: CreateDocumentApiV1DocumentsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Document>> {
        if (requestParameters['documentCreate'] == null) {
            throw new runtime.RequiredError(
                'documentCreate',
                'Required parameter "documentCreate" was null or undefined when calling createDocumentApiV1DocumentsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/documents/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DocumentCreateToJSON(requestParameters['documentCreate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DocumentFromJSON(jsonValue));
    }

    /**
     * Create new document.
     * Create Document
     */
    async createDocumentApiV1DocumentsPost(requestParameters: CreateDocumentApiV1DocumentsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Document> {
        const response = await this.createDocumentApiV1DocumentsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create new document.
     * Create Document
     */
    async createDocumentApiV1DocumentsPost_1Raw(requestParameters: CreateDocumentApiV1DocumentsPost0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Document>> {
        if (requestParameters['documentCreate'] == null) {
            throw new runtime.RequiredError(
                'documentCreate',
                'Required parameter "documentCreate" was null or undefined when calling createDocumentApiV1DocumentsPost_1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/documents`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DocumentCreateToJSON(requestParameters['documentCreate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DocumentFromJSON(jsonValue));
    }

    /**
     * Create new document.
     * Create Document
     */
    async createDocumentApiV1DocumentsPost_1(requestParameters: CreateDocumentApiV1DocumentsPost0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Document> {
        const response = await this.createDocumentApiV1DocumentsPost_1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a document.
     * Delete Document
     */
    async deleteDocumentApiV1DocumentsIdDeleteRaw(requestParameters: DeleteDocumentApiV1DocumentsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Document>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteDocumentApiV1DocumentsIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/documents/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DocumentFromJSON(jsonValue));
    }

    /**
     * Delete a document.
     * Delete Document
     */
    async deleteDocumentApiV1DocumentsIdDelete(requestParameters: DeleteDocumentApiV1DocumentsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Document> {
        const response = await this.deleteDocumentApiV1DocumentsIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get document by ID.
     * Read Document
     */
    async readDocumentApiV1DocumentsIdGetRaw(requestParameters: ReadDocumentApiV1DocumentsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Document>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling readDocumentApiV1DocumentsIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/documents/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DocumentFromJSON(jsonValue));
    }

    /**
     * Get document by ID.
     * Read Document
     */
    async readDocumentApiV1DocumentsIdGet(requestParameters: ReadDocumentApiV1DocumentsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Document> {
        const response = await this.readDocumentApiV1DocumentsIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve documents.
     * Read Documents
     */
    async readDocumentsApiV1DocumentsGetRaw(requestParameters: ReadDocumentsApiV1DocumentsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Document>>> {
        const queryParameters: any = {};

        if (requestParameters['skip'] != null) {
            queryParameters['skip'] = requestParameters['skip'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/documents/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DocumentFromJSON));
    }

    /**
     * Retrieve documents.
     * Read Documents
     */
    async readDocumentsApiV1DocumentsGet(requestParameters: ReadDocumentsApiV1DocumentsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Document>> {
        const response = await this.readDocumentsApiV1DocumentsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve documents.
     * Read Documents
     */
    async readDocumentsApiV1DocumentsGet_2Raw(requestParameters: ReadDocumentsApiV1DocumentsGet0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Document>>> {
        const queryParameters: any = {};

        if (requestParameters['skip'] != null) {
            queryParameters['skip'] = requestParameters['skip'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/documents`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DocumentFromJSON));
    }

    /**
     * Retrieve documents.
     * Read Documents
     */
    async readDocumentsApiV1DocumentsGet_2(requestParameters: ReadDocumentsApiV1DocumentsGet0Request = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Document>> {
        const response = await this.readDocumentsApiV1DocumentsGet_2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all documents for a specific prosecution.
     * Read Documents By Prosecution
     */
    async readDocumentsByProsecutionApiV1DocumentsProsecutionProsecutionIdGetRaw(requestParameters: ReadDocumentsByProsecutionApiV1DocumentsProsecutionProsecutionIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Document>>> {
        if (requestParameters['prosecutionId'] == null) {
            throw new runtime.RequiredError(
                'prosecutionId',
                'Required parameter "prosecutionId" was null or undefined when calling readDocumentsByProsecutionApiV1DocumentsProsecutionProsecutionIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/documents/prosecution/{prosecution_id}/`.replace(`{${"prosecution_id"}}`, encodeURIComponent(String(requestParameters['prosecutionId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DocumentFromJSON));
    }

    /**
     * Get all documents for a specific prosecution.
     * Read Documents By Prosecution
     */
    async readDocumentsByProsecutionApiV1DocumentsProsecutionProsecutionIdGet(requestParameters: ReadDocumentsByProsecutionApiV1DocumentsProsecutionProsecutionIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Document>> {
        const response = await this.readDocumentsByProsecutionApiV1DocumentsProsecutionProsecutionIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all documents for a specific prosecution.
     * Read Documents By Prosecution
     */
    async readDocumentsByProsecutionApiV1DocumentsProsecutionProsecutionIdGet_3Raw(requestParameters: ReadDocumentsByProsecutionApiV1DocumentsProsecutionProsecutionIdGet0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Document>>> {
        if (requestParameters['prosecutionId'] == null) {
            throw new runtime.RequiredError(
                'prosecutionId',
                'Required parameter "prosecutionId" was null or undefined when calling readDocumentsByProsecutionApiV1DocumentsProsecutionProsecutionIdGet_3().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/documents/prosecution/{prosecution_id}`.replace(`{${"prosecution_id"}}`, encodeURIComponent(String(requestParameters['prosecutionId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DocumentFromJSON));
    }

    /**
     * Get all documents for a specific prosecution.
     * Read Documents By Prosecution
     */
    async readDocumentsByProsecutionApiV1DocumentsProsecutionProsecutionIdGet_3(requestParameters: ReadDocumentsByProsecutionApiV1DocumentsProsecutionProsecutionIdGet0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Document>> {
        const response = await this.readDocumentsByProsecutionApiV1DocumentsProsecutionProsecutionIdGet_3Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a document.
     * Update Document
     */
    async updateDocumentApiV1DocumentsIdPutRaw(requestParameters: UpdateDocumentApiV1DocumentsIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Document>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateDocumentApiV1DocumentsIdPut().'
            );
        }

        if (requestParameters['documentUpdate'] == null) {
            throw new runtime.RequiredError(
                'documentUpdate',
                'Required parameter "documentUpdate" was null or undefined when calling updateDocumentApiV1DocumentsIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/documents/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DocumentUpdateToJSON(requestParameters['documentUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DocumentFromJSON(jsonValue));
    }

    /**
     * Update a document.
     * Update Document
     */
    async updateDocumentApiV1DocumentsIdPut(requestParameters: UpdateDocumentApiV1DocumentsIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Document> {
        const response = await this.updateDocumentApiV1DocumentsIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
